import { buildCsvDocument } from './csvUtils';

export type CalendarListExportRow = {
  start: string;
  end: string;
  title: string;
  project: string;
  address: string;
  projectLeads: string;
  crew: string;
  type: string;
  status: string;
};

export const CALENDAR_LIST_CSV_HEADERS = [
  'Start',
  'Ende',
  'Aktivität',
  'Projekt',
  'Adresse',
  'Projektleiter',
  'Einsatzteam',
  'Typ',
  'Status',
] as const;

export function buildCalendarListCsv(rows: CalendarListExportRow[]): string {
  return buildCsvDocument(
    [...CALENDAR_LIST_CSV_HEADERS],
    rows.map((row) => [
      row.start,
      row.end,
      row.title,
      row.project,
      row.address,
      row.projectLeads,
      row.crew,
      row.type,
      row.status,
    ]),
  );
}

export function downloadCalendarListCsv(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function calendarListExportFilename(dateFrom: string | null, dateTo: string | null): string {
  const today = new Date();
  const y = today.getFullYear();
  const m = String(today.getMonth() + 1).padStart(2, '0');
  const d = String(today.getDate()).padStart(2, '0');
  const stamp = `${y}-${m}-${d}`;
  if (dateFrom && dateTo) return `kalender-liste_${dateFrom}_${dateTo}.csv`;
  if (dateFrom) return `kalender-liste_ab_${dateFrom}.csv`;
  if (dateTo) return `kalender-liste_bis_${dateTo}.csv`;
  return `kalender-liste_${stamp}.csv`;
}
